import { useEffect } from 'react'
import DefaultPending from '@/components/DefaultPending'
import { adminTitleHead } from '@/lib/admin-route-title'
import { stripeConnectQueries } from '@/lib/services/stripe-connect/stripe-connect.query'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { z } from 'zod/v4'

const stripeConnectResolverSearchSchema = z.object({
  stripe_account_id: z.string().min(1),
  target: z.enum(['onboarding', 'account']).catch('account'),
})

export const Route = createFileRoute('/_authenticated/stripe-connect')({
  component: StripeConnectResolverPage,
  head: () => adminTitleHead('Stripe Connect'),
  validateSearch: (search) => stripeConnectResolverSearchSchema.parse(search),
  loaderDeps: ({ search }) => ({
    stripeAccountId: search.stripe_account_id,
    target: search.target,
  }),
  loader: async ({ context, deps }) => {
    if (!context.ability.can('edit', 'stripe-account')) {
      throw notFound()
    }

    const organizationId = context.authState?.user?.organization_id

    return await context.queryClient.ensureQueryData(
      stripeConnectQueries.resolveAccount({
        organizationId,
        stripeAccountId: deps.stripeAccountId,
        target: deps.target,
      })
    )
  },
})

function StripeConnectResolverPage() {
  const { redirect_url: redirectUrl } = Route.useLoaderData()

  useEffect(() => {
    if (redirectUrl) {
      window.location.replace(redirectUrl)
    }
  }, [redirectUrl])

  return (
    <div className="mx-auto max-w-xl py-12" data-testid="stripe-connect-resolver-loading">
      <DefaultPending className="h-auto min-h-[160px]" />
    </div>
  )
}
